import 'css/src/components/common/ui/Callout';

import React from 'react';
import classnames from 'classnames';

import { BUTTON_SIZES, BUTTON_WIDTHS, SimpleButton } from 'js/src/components/common/ui/Button';

export enum CALLOUT_TYPES {
    INFO = 'info',
    ERROR = 'error',
    BLANK = 'blank',
    UPSELL = 'upsell',
}

type Props = {
    msgType?: CALLOUT_TYPES;
    dismissHandler?: (event?: React.MouseEvent) => void;
    dismissable?: boolean;
    visible?: boolean;
    className?: string;
    children?: React.ReactNode;
};

const Callout: React.FC<Props> = React.memo(function Callout({
    msgType = CALLOUT_TYPES.INFO,
    dismissHandler = undefined,
    dismissable = false,
    visible = true,
    className = '',
    children,
}) {
    const [showing, setShowing] = React.useState(visible);
    const onDismiss = React.useCallback(
        (e: React.MouseEvent) => {
            setShowing(false);
            if (dismissHandler) {
                dismissHandler(e);
            }
        },
        [dismissHandler],
    );

    if (!showing) {
        return null;
    }

    return (
        <div
            className={classnames(className, 'alert callout', {
                'alert-dismissible': dismissable,
                'callout-info': msgType === CALLOUT_TYPES.INFO,
                'callout-error': msgType === CALLOUT_TYPES.ERROR,
                'callout-blank': msgType === CALLOUT_TYPES.BLANK,
                'callout-upsell': msgType === CALLOUT_TYPES.UPSELL,
            })}
            role="alert"
        >
            {dismissable && (
                <SimpleButton
                    width={BUTTON_WIDTHS.NO_MIN_WIDTH}
                    size={BUTTON_SIZES.MD}
                    className="btn-close mt-l5-4 me-l5-4"
                    aria-label="Close"
                    onClick={onDismiss}
                />
            )}
            {children}
        </div>
    );
});

export default Callout;
